export interface ITranslation {
    [key: string]: ({}?: { [arg: string]: string|number }) => string;
  }
  
  export interface ILocales {
    [locale: string]: ITranslation;
  }
  
  const locales: ILocales = {
    en: {
      accessNotFound: () => ('Not Found'),
      hour: ({ hour }: { hour: number }) => (`${hour} hour${hour <= 1.0 ? '' : 's'}`),
      minute: ({ minute }: { minute: number }) => (`${minute} minute${minute <= 1.0 ? '' : 's'}`),
    },
    ja: {
      accessNotFound: () => ('見つかりませんでした'),
      hour: ({ hour }: { hour: number }) => (`${hour} 時間`),
      minute: ({ minute }: { minute: number }) => (`${minute} 分`),
    },
    'zh-CN': {
      accessNotFound: () => ('未找到交通路线'),
      hour: ({ hour }: { hour: number }) => (`${hour} 小时`),
      minute: ({ minute }: { minute: number }) => (`${minute} 分`),
    },
    'zh-HK': {
      accessNotFound: () => ('未找到交通路線'),
      hour: ({ hour }: { hour: number }) => (`${hour} 小時`),
      minute: ({ minute }: { minute: number }) => (`${minute} 分`),
    },
    'zh-TW': {
      accessNotFound: () => ('未找到交通路線'),
      hour: ({ hour }: { hour: number }) => (`${hour} 小時`),
      minute: ({ minute }: { minute: number }) => (`${minute} 分`),
    },
  };
  
  export default locales;
  